import type { AnalyzedSolanaTransaction } from '@0xtorch/solana'
import { analyzeSolanaTransaction as analyzeTransaction } from '@0xtorch/solana'
import type { AnalyzeSolanaTransactionParameters } from './types'

export const analyzeSolanaTransaction = async ({
  transaction,
  tokenAccountOwnerMap,
  splTokenDatasource,
  jsonDatasource,
  accountIds,
}: AnalyzeSolanaTransactionParameters): Promise<AnalyzedSolanaTransaction> => {
  const analyzedTransaction = await analyzeTransaction({
    transaction,
    tokenAccountOwnerMap,
    splTokenDatasource,
    jsonDatasource,
    accountIds,
  })
  return analyzedTransaction
}
